import { useIntl } from "react-intl";

import { EnterpriseHero } from "@/components/enterprise/enterprise-hero-v2/src/enterprise-hero";
import { useLocalizedHref } from "@/libraries/web-framework";

export const ProductTabContent = () => {
    const intl = useIntl();

    return (
        <EnterpriseHero
            headerText={intl.formatMessage({
                id: "EnterpriseLandingPage.hero.product.header",
                defaultMessage: "Say Hello to Rovo"
            })}
            bodyText={intl.formatMessage({
                id: "EnterpriseLandingPage.hero.product.body",
                defaultMessage:
                    "Atlassian's AI-powered solution that makes teamwork easier and faster."
            })}
            textAlign="center"
            cta={{
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.hero.product.cta",
                    defaultMessage: "Learn more"
                }),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "heroSection",
                    "data-event": "clicked",
                    "data-label": "enterprise-hero-product-cta",
                    "data-label-english": "Learn more"
                },
                href: useLocalizedHref("/software/rovo")
            }}
            ctaType="button"
            color="dark"
            backgroundImgSrc={{
                xs: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-mobile@2x-1408243573.webp",
                sm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-tablet@2x-1411287807.webp",
                md: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-desktop-S@2x-1748573145.webp",
                lg: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-desktop-L@2x-2396412742.webp"
            }}
        />
    );
};
